// Design tokens — single source of truth for colors, fonts, and tracking.
// Mirrors design.md. Do NOT introduce new colors or fonts elsewhere; import
// from here so we keep the Aevara palette honest.

export const COLORS = {
  // Primary brand
  blue: "#2A286B",
  holidayBlue: "#2AC0D0",
  cream: "#E7E0C6",
  accent: "#2563FF",

  // Extended palette
  deepBlue: "#1A1A4A",
  slateBlue: "#5B5FA8",
  creamLight: "#F5F1E4",

  // Neutrals
  white: "#FFFFFF",
  offWhite: "#FAFBFC",
  lightGray: "#EDEFF5",
  medGray: "#8A8FA8",
  darkGray: "#2E3142",
  bgDark: "#0B1020",

  // Dark theme
  bgApp: "#111827",       // page background
  surface: "#0B1020",     // card surface on bgApp
  surfaceHigh: "#1C2040", // elevated card / hover surface
  border: "rgba(255,255,255,0.07)",
  borderButton: "rgba(255,255,255,0.22)",
  textPrimary: "#F9FAFB",
  textSecondary: "#e5e7eb",
  textMuted: "rgba(249,250,251,0.55)",  // raised from 0.38 → WCAG AA contrast
};

export const FONTS = {
  heading:
    "'Area Normal', 'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  body:
    "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

// Letter-spacing tokens — uppercase headlines and kickers are an Aevara
// brand signature and need generous tracking. Pair every uppercase
// treatment with one of these values.
export const TRACKING = {
  headline: "0.06em",   // page + section headlines (uppercase)
  level: "0.04em",      // large level labels
  button: "0.08em",     // uppercase button text
  kicker: "0.2em",      // small uppercase eyebrow text
  tightHeadline: "-0.01em", // sentence-case headlines (slight tightening)
};
